import getWrappedUseMutation from "../../../api/helpers/getWrappedUseMutation";
import apiClient from "../../../api-client";

export const useCreateSeminarSessionMutation = getWrappedUseMutation(apiClient.ForumSeminarSessions.post);

export const useUpdateSeminarSessionMutation = getWrappedUseMutation(apiClient.ForumSeminarSessions.put);

export const useDeleteSeminarSessionMutation = getWrappedUseMutation(apiClient.ForumSeminarSessions.delete);
